import { useEffect, useRef } from 'react';

const defaultEvents = ['mousedown', 'touchstart'];

const useTriggerSelect = (ref, onTrigger, events = defaultEvents) => {
  const savedCallback = useRef(onTrigger);

  useEffect(() => {
    savedCallback.current = onTrigger;
  }, [onTrigger]);

  useEffect(() => {
    const handler = event => {
      const { current: el } = ref;

      if (el && !el?.contains?.(event.target)) {
        savedCallback.current(event);
      }
    };

    for (const eventName of events) {
      document.addEventListener(eventName, handler);
    }

    return () => {
      for (const eventName of events) {
        document.removeEventListener(eventName, handler);
      }
    };
  }, [events, ref]);
};

export default useTriggerSelect;
